import { useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import '../ContactUs/ContactUs.css';
import { useTranslation } from 'react-i18next';

function ContactUs () {

    const [showContactUs, setShowContactUs] = useState(false);

    const handleCloseConctactUs = () => setShowContactUs(false);
    const handleShowConctactUs = () => setShowContactUs(true);

    const { i18n, t } = useTranslation()

    return (
        <Container>
            <a className="btn-flotante" onClick={handleShowConctactUs}>{t('contact')}</a>

            <Modal show={showContactUs} onHide={handleCloseConctactUs} aria-labelledby="contained-modal-title-vcenter">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                 Contactanos!
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="grid-example">
                <Container style={{ textAlign: 'center'}}>
                    <hr/>
                    <Row>
                        <Col xs={12} md={12}>
                            <h2>{t('Email')}</h2>
                            <p>ababebidas@gmail.com</p>
                        </Col>
                    </Row>
                    <hr/>
                    <Row>
                        <Col xs={12} md={12}>
                            <h2>{t('cellPhone')}</h2>
                            <p>+5491121558484</p>
                        </Col>
                    </Row>
                    <hr/>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleCloseConctactUs}>{t('close')}</Button>
            </Modal.Footer>
            </Modal>

        </Container>


    );
}

export default ContactUs;